import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { Warning, ErrorOutline, Info } from '@mui/icons-material';

const ViolationModal = ({ open, title, message, type, onConfirm }) => {
  const getIcon = () => {
    switch (type) {
      case 'termination':
        return <ErrorOutline sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />;
      case 'warning':
        return <Warning sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />;
      default:
        return <Info sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onConfirm();
        }
      }}
      aria-labelledby="violation-modal-title"
      aria-describedby="violation-modal-description"
      PaperProps={{
        style: {
          borderRadius: "0",
          padding: '16px',
          minWidth: 'min(350px, calc(100vw - 32px))',
          textAlign: 'center'
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
        {getIcon()}
        <DialogTitle id="violation-modal-title" sx={{ pt: 0, fontWeight: 'bold' }}>
          {title}
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText id="violation-modal-description" sx={{ color: 'text.primary', fontSize: '1.1rem' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color={type === 'termination' ? 'error' : 'primary'}
          autoFocus
          sx={{ px: 4, borderRadius: "0 !important" }}
        >
          {type === 'termination' ? 'Understood' : 'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViolationModal;
